import React from "react";
import { Link } from "react-router-dom";
import NavigationHeader from "../../components/ui/NavigationHeader";
import { useAuth } from "../../contexts/AuthContext";

export default function Legal() {
  const { user, userProfile } = useAuth();
  const currentTier = userProfile?.subscription_tier || "free";

  return (
    <div className="min-h-screen min-h-[100dvh] bg-background">
      <NavigationHeader
        user={{ name: user?.email?.split("@")[0] || "Utilisateur" }}
        subscriptionTier={currentTier}
      />

      <main className="max-w-4xl mx-auto px-4 pt-24 pb-10">
        <div className="mb-8">
          <h1 className="text-3xl font-semibold text-foreground">Avertissement légal</h1>
          <p className="mt-2 text-sm text-muted-foreground">
            Dernière mise à jour : {new Date().toLocaleDateString("fr-CA")}
          </p>
        </div>

        <div className="prose prose-neutral max-w-none dark:prose-invert">
          <p>
            Le contenu et les outils de <strong>ImmoIQ</strong> sont fournis à titre informatif
            uniquement et ne constituent pas un avis financier, juridique, fiscal ou comptable.
          </p>

          <h2>1. Aucune garantie</h2>
          <p>
            Les résultats dépendent des informations saisies et/ou extraites de sources externes.
            Malgré nos efforts, des erreurs peuvent survenir. Validez les informations importantes.
          </p>

          <h2>2. Responsabilité</h2>
          <p>
            Toute décision d’investissement demeure votre responsabilité. ImmoIQ ne peut être tenu
            responsable des pertes ou dommages liés à l’utilisation du Service.
          </p>

          <h2>3. Sites tiers</h2>
          <p>
            ImmoIQ n’est pas affilié aux sites tiers analysés par URL et ne contrôle pas leur contenu.
          </p>

          <h2>4. IA : limites</h2>
          <p>
            L’IA peut produire des erreurs. Vérifiez toujours taxes, revenus, dépenses et documents
            officiels.
          </p>

          <h2>5. Contact</h2>
          <p>
            Une question ? <Link className="underline" to="/contact">Contactez-nous</Link>.
          </p>
        </div>
      </main>
    </div>
  );
}
